export const currency = {
  get_all: "products/currency/",
  create: "products/currency/",
  get_by_id: (id: number) => `products/currency/get-by/?id=${id}`,
  delete: (id: number) => `products/currency/?id=${id}`,
  edit: (id: number) => `products/currency/?id=${id}`,
};
